import React from "react";
import "./A2Page.css"
const A2CourseDetails = () => {
  return (
    <div className="a2DetailsContainer">
      <ul>
        <li>It is the Elementary Level or The Upper Beginner Level</li>
        <li>Duration of this course is 45-50 hours.</li>
        <li>One can understand Sentences and Frequently used Expressions</li>
        <li>
          This course offers an understanding on Common Topics which enables one
          to make him/ herself understood in simple, routine situations.
        </li>
        <li>
          It includes core structure and grammar that will take your German to
          the next level.
        </li>
        <li>Entire course focuses on Theme Based Topics</li>
      </ul>
      <h3>What to expect after completion of this course?</h3>
      <ul>
        <li>
          One can easily conduct Conversations at Railway Stations or Offices
        </li>
        <li>Read and Understand Simple Texts</li>
        <li>Framing simply Connected Texts</li>
        <li>Answering “Why” Questions</li>
        <li>Talking about Cause and Effect (i.e when- then Sentences)</li>
        <li>Comparing different things</li>
        <li>Be able to Express Yourself Politely in Formal Situations</li>
      </ul>
    </div>
  );
};

export default A2CourseDetails;
